import { Component, OnInit } from '@angular/core';
import {AuthService}  from "../../services/auth.service";


@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent{
	
   constructor(public authService:AuthService){}
	
}
